<template>
  <td
    style="word-break: break-all"
    :key="column.ColumnName"
    :class="column.class"
  >
    <div v-if="column.ColumnName == 'Active'" class="flex-start-center w-100">
      <div v-if="column.hasSpecification" class="active-class">
        <img
          :style="item.IsMultiSpecification ? '' : 'filter: grayscale(100%)'"
          :src="$img.get('Icon/Specification.svg')"
          alt="多規格"
        />
        <div class="active-name">多規格</div>
      </div>
      <div v-if="column.hasERP" class="active-class">
        <img
          :style="item.IsStock ? '' : 'filter: grayscale(100%)'"
          :src="$img.get('Icon/Stock.svg')"
          alt="扣庫存"
        />
        <div class="active-name">扣庫存</div>
      </div>
      <div v-if="column.hasBatchNumber" class="active-class flex-1">
        <img
          :style="item.HasBatchNumber ? '' : 'filter: grayscale(100%)'"
          :src="$img.get('Icon/BatchNumber.svg')"
          alt="批號"
        />
        <div class="active-name">批號</div>
      </div>
    </div>
    <div
      v-else-if="column.ColumnName == 'SalePayType'"
      class="flex-start-start flex-column"
    >
      <div
        class="sale-pay"
        v-for="(pay, index) in visibleSalePays"
        :key="pay.PayId"
        :style="index < visibleSalePays.length - 1 ? 'margin-bottom: 8px' : ''"
      >
        {{ pay.PayName + "：" + pay.Total }}
      </div>
    </div>
    <div
      v-else-if="column.ColumnName == 'StatusText'"
      class="flex-start-start flex-column"
    >
      <div v-if="item.IsFree" class="sale-pay">贈送</div>
    </div>
    <div
      v-else-if="column.ColumnName == 'EmailResultTypeText'"
      class="email-status"
      :class="
        item.EmailResultTypeText == '未寄送'
          ? 'unsend'
          : item.EmailResultTypeText == '傳輸中'
          ? 'sending'
          : item.EmailResultTypeText == '失敗'
          ? 'failed'
          : item.EmailResultTypeText == '成功'
          ? 'success'
          : 'rejected'
      "
    >
      {{ item.EmailResultTypeText }}
    </div>
    <div
      v-else-if="column.isStatus"
      class="is-status"
      :class="checkFilter(column.filter) ? '' : 'none'"
    >
      {{ checkFilter(column.filter) ? "已上傳" : "未上傳" }}
    </div>
    <div
      v-else-if="column.ColumnName == 'MultiSolution'"
      class="flex-start-start flex-column"
    >
      <div
        class="flex-start-center"
        v-for="(tdItem, index) in item.Items"
        :key="index"
        style="height: 24px"
        :style="index < item.Items.length - 1 ? 'margin-bottom: 8px' : ''"
      >
        <div class="flex-start-stretch h-100">
          <div class="text-right" style="width: 60px">
            {{
              column.titleProperty
                ? tdItem[column.titleProperty]
                : "" + tdItem[column.itemProperty] + "元："
            }}
          </div>
          <div class="flex-end-center mt-2px" style="width: 36px">
            {{ tdItem[column.firstValue] }}
          </div>
          <img
            v-if="column.linkImg"
            :src="column.linkImg"
            alt=""
            class="px-5px"
          />
          <div class="flex-start-center mt-2px">
            <div :class="tdItem[column.thirdValue] ? 'minus' : ''">
              {{ tdItem[column.secondValue] }}
            </div>
            <div v-if="tdItem[column.thirdValue]" class="px-5px">
              {{ `(${tdItem[column.thirdValue]})` }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      :class="[
        column.hasAddCircleButton ? 'flex-start-center' : '',
        column.isClickable ? 'clickable' : '',
        column.compareWith && item[column.ColumnName] < 0
          ? 'minus'
          : column.compareWith &&
            item[column.ColumnName] < item[column.compareWith]
          ? 'lower'
          : '',
      ]"
      @click="
        column.isClickable
          ? $emit('clickTd', { ClickColumn: column.ColumnName, ...item })
          : null
      "
    >
      <slot name="td-button"
        ><button v-if="column.btnText">{{ column.btnText }}</button></slot
      >
      {{ checkFilter(column.filter) }}
    </div>
  </td>
</template>

<script>
import currencyFilter from "@/filters/currency";
import discountFilter from "@/filters/discount";

export default {
  props: ["column", "item"],
  computed: {
    visibleSalePays() {
      if (!Array.isArray(this.item?.SalePays)) return [];
      return this.item.SalePays.filter((pay) => Number(pay.Total) !== 0);
    },
  },
  methods: {
    checkFilter(filter) {
      if (filter === null) return this.item[this.column.ColumnName];
      if (filter) {
        if (filter == "currency") {
          return currencyFilter(this.item[this.column.ColumnName]);
        } else if (filter == "discount") {
          return discountFilter(this.item[this.column.ColumnName]);
        }
      }
      return this.item[this.column.ColumnName];
    },
  },
};
</script>

<style lang="scss" scoped>
.clickable {
  transition: all 0.2s;
  button {
    cursor: pointer;
    font-size: 16px;
    background-color: #4695c9;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 5px 16px;
  }
  &:hover {
    filter: brightness(1.05);
  }
}
.is-status {
  display: inline-block;
  padding: 1px 8px 2px;
  color: #77bb63;
  background-color: #f2fcef;
  border: 1px solid #77bb63;
  border-radius: 4px;
  &.none {
    color: #4695c9;
    background-color: #ecf3f8;
    border: 1px solid #4695c9;
  }
}
.lower {
  color: #e39247;
}
.minus {
  color: #ff3b30;
}
</style>
